"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 4
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
function CategoriesGrid() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="aspect-square md:aspect-[4/3] rounded-xl bg-muted/20 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground py-12">
        <p>Impossibile caricare i moduli di protezione al momento.</p>
      </div>;
  }
  const displayItems = terms.length > 0 ? terms.slice(0, 4).map(term => ({
    id: term.id.toString(),
    name: term.name,
    description: term.description || "Scopri i dettagli e le specifiche tecniche di questo modulo di sicurezza avanzato.",
    image: term.image_url || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666921/img/generic_security_module.png",
    link: term.link || "/ShopPage"
  })) : [{
    id: 'static-1',
    name: "Antintrusione",
    description: "Rilevamento preciso e immediato di ogni tentativo di accesso non autorizzato, con sensori di movimento e contatti magnetici ad alta sensibilità.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666921/img/modulo_antintrusione_secureasy.png",
    link: "/ShopPage"
  }, {
    id: 'static-2',
    name: "Rilevamento Furti",
    description: "Protezione avanzata per i tuoi beni più preziosi con barriere a infrarossi e rilevatori di rottura vetri di ultima generazione.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666921/img/modulo_furto_secureasy.png",
    link: "/ShopPage"
  }, {
    id: 'static-3',
    name: "Videosorveglianza",
    description: "Controllo visivo costante in alta definizione, accessibile ovunque ti trovi tramite app, con visione notturna e registrazione cloud.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666921/img/modulo_video_secureasy.png",
    link: "/ShopPage"
  }, {
    id: 'static-4',
    name: "Prevenzione Incendi",
    description: "Sensori intelligenti per fumo, calore e monossido di carbonio, per un intervento tempestivo e salvavita in caso di emergenza.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666921/img/modulo_incendio_secureasy.png",
    link: "/ShopPage"
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
      {displayItems.map((item, i) => <Link key={item.id} to={item.link} data-index={i} className="group relative overflow-hidden rounded-xl aspect-square md:aspect-[4/3] bg-muted/10 block border border-border/50">
          <img src={item.image} alt={item.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" {...item.id.startsWith('static') ? {
        "data-wvc-srcset": `${item.image}-wvc-srcset`,
        "data-wvc-sizes": `${item.image}-wvc-sizes`
      } : {}} />
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent transition-opacity duration-500 group-hover:from-black/95 group-hover:via-black/60" />
          
          <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 font-default transform transition-transform duration-500 ease-out group-hover:-translate-y-2">
              {item.name}
            </h3>
            
            <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500 ease-in-out">
              <div className="overflow-hidden">
                <p className="text-white/80 text-sm md:text-base mt-2 transform translate-y-4 opacity-0 transition-all duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100">
                  {item.description}
                </p>
                <div className="mt-4 inline-flex items-center text-primary font-medium text-sm transform translate-y-4 opacity-0 transition-all duration-500 delay-100 ease-out group-hover:translate-y-0 group-hover:opacity-100">
                  Scopri di più
                  <svg className="ml-2 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </Link>)}
    </div>;
}
export default function ModuliDiProtezioneEspandibili() {
  return <section id="moduli-di-protezione-espandibili" className="bg-background text-foreground py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default mb-6">
            Espansione a Piacimento
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Il sistema Secureasy cresce con le tue esigenze. Aggiungi moduli funzionali in qualsiasi momento per una sicurezza su misura, dal rilevamento intrusioni alla prevenzione incendi.
          </p>
        </div>
        
        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <CategoriesGrid />
        </EcommerceTermsProvider>
      </div>
    </section>;
}